<template lang="pug">
  v-dialog(
    v-model="innerVisible"
    width="100%" persistent
    overlay-opacity="0.95"
    :max-width="maxWidth")

    v-card.my-4.mx-auto.py-6.px-2.rounded-lg(max-width="640" elevation="0" style="position: relative;")
      v-btn.mt-10(v-if="!hideClose" elevation="0" :ripple="false" plain fab absolute top right @click="innerVisible = false")
        v-icon mdi-close
      slot
      
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    hideClose: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [Number, String],
      default: 800
    }
  },
  data() {
    return {
      
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>